export enum FeatureFlag {
  REBRAND_V2_MONOLITH_REACT = "rebrand-v2-monolith-react",
  NO_APARTMENT_REDIRECT = "no-apartment-redirect",
  NEW_GET_STARTED_PAGE = "NEW_GET_STARTED_PAGE",
  NEW_STILL_HAVE_QUESTIONS_DESIGN = "NEW_STILL_HAVE_QUESTIONS_DESIGN",
  ENABLE_FOOTER_TRUST_CENTER = "enable_footer_trust_center",
  ENABLE_FOOTER_MARKETPLACE = "enable_footer_marketplace",
  ENABLE_FOOTER_BLOG_RENAME = "enable_footer_blog_rename",
  REMOVE_FOOTER_CONTACT_US = "remove_footer_contact_us",
  REN_5067_UNENROLLED_FLOW = "REN_5067_UNENROLLED_FLOW", //name is wrong, but it's for RENTERS, not for UNENROLLED
  REN_5245_RENTERS_FLOW_AB_TEST = "REN-5245_renters_flow_ab_test",
  REN_5179_UNENROLLED_FLOW = "REN-5179_UNENROLLED_FLOW",
  REN_5179_UNENROLLED_FLOW_AB_TEST = "REN-5179_UNENROLLED_FLOW_AB_TEST",
  TEST_FEATURE = "test_feature"
}
